import React from "react";
import { Slide, toast } from "react-toastify";

export const Severty = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
}

const AUTO_CLOSE_MS = 2800;

const KNOWN_TYPES = [Severty.SUCCESS, Severty.ERROR, Severty.WARNING, Severty.INFO];

const ICON_PATHS = {
    success: <path className="ime-toast-icon-path" d="M5 13l4 4L19 7" />,
    error: <path className="ime-toast-icon-path" d="M18 6L6 18M6 6l12 12" />,
    warning: (
        <>
            <path className="ime-toast-icon-path" d="M10.6 3.9 1.8 18.6a1.6 1.6 0 0 0 1.4 2.4h17.6a1.6 1.6 0 0 0 1.4-2.4L13.4 3.9a1.6 1.6 0 0 0-2.8 0Z" />
            <path className="ime-toast-icon-path" d="M12 9v4M12 16.5h.01" />
        </>
    ),
    info: (
        <>
            <circle className="ime-toast-icon-path" cx="12" cy="12" r="9" />
            <path className="ime-toast-icon-path" d="M12 11v5M12 8h.01" />
        </>
    ),
};

const toMessageText = (message) => {
    if (typeof message === "string") return message;
    if (message?.response?.data?.message) return message.response.data.message;
    if (message?.message) return message.message;
    if (message == null) return "";
    try {
        return JSON.stringify(message);
    } catch {
        return String(message);
    }
};

const ToastIcon = ({ type }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        {ICON_PATHS[type]}
    </svg>
);

const ToastBody = ({ type, message }) => (
    <div className="ime-toast-wrap">
        <div className="ime-toast-row">
            <span className="ime-toast-icon">
                <ToastIcon type={type} />
            </span>
            <span className="ime-toast-message">{message}</span>
        </div>
        <div className="ime-toast-rule">
            <span className="ime-toast-rule-fill" style={{ animationDuration: `${AUTO_CLOSE_MS}ms` }} />
        </div>
    </div>
);

const CloseButton = ({ closeToast }) => (
    <button type="button" className="ime-toast-close" onClick={closeToast} aria-label="Close notification">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 6L6 18M6 6l12 12" />
        </svg>
    </button>
);

const baseOptions = (type) => ({
    position: "top-center",
    autoClose: AUTO_CLOSE_MS,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    pauseOnFocusLoss: false,
    draggable: false,
    icon: false,
    closeButton: CloseButton,
    transition: Slide,
    type,
});

export const ShowToast = (message, type) => {
    if (!KNOWN_TYPES.includes(type)) return;
    toast(<ToastBody type={type} message={toMessageText(message)} />, baseOptions(type));
}
